// src/services/employeeApi.ts
import apiClient from "./apiClient";

export const fetchEmployees = () => apiClient.get("/settings/employees");

export const inviteEmployee = (
  email: string,
  role = "employee",
  commission = 0
) => apiClient.post("/settings/employees/invite", { email, role, commission });

export const updateEmployeeRole = (id: string, role: string, commission = 0) =>
  apiClient.patch(`/settings/employees/${id}/role`, {
    newRole: role,
    newCommission: commission,
  });

export const removeEmployee = (id: string) =>
  apiClient.delete(`/settings/employees/${id}`);
